import React from 'react';
import { Select } from 'antd';
import useLanguageSelector from './languageSelector.hook';
import styles from './languageSelector.styles';
import { useHotelLangSelection } from 'context/HotelLangSelectionContext';
const { Option } = Select;

export default function LanguageSelectorMultiple({
  mode = 'multiple',
  isLoading = false,
  customStyles = {},
}) {  
  
  
  const { setSelectedLanguages } = useHotelLangSelection();

  const isMultiple = mode === 'multiple';
  const { languages, selectedLanguageCode, selectLanguage, selectMultipleLanguages } =
    useLanguageSelector(setSelectedLanguages, isMultiple);

  const value = isMultiple
    ? selectedLanguageCode.map(code => (code === null ? 'null' : code))
    : selectedLanguageCode === null
    ? 'null'
    : selectedLanguageCode;

  return (
    <div>
      <Select
        mode={isMultiple ? 'multiple' : undefined}
        allowClear={true}
        style={{ ...styles.selectorMultiple, ...customStyles }}
        value={value}
        onChange={isMultiple ? selectMultipleLanguages : selectLanguage}
        optionFilterProp="children"
        disabled={isLoading}
        placeholder="Select language(s)"
        bordered={true}
      >
        {languages.map(language => (
          <Option
            key={language.code === null ? 'null' : language.code}
            value={language.code === null ? 'null' : language.code}
            disabled={isLoading}
          >
            {language.label}
          </Option>
        ))}
      </Select>
    </div>
  );
}
